class ServerURL {
  static getAPIUrl() {
    var apiURL = process.env.REACT_APP_API_ENDPOINT;
    return apiURL;
  }
}
export default ServerURL;
